import { render } from "./WLoading.vue?vue&type=template&id=8a56a484&ts=true"
import script from "./WLoading.vue?vue&type=script&lang=ts"
export * from "./WLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__